export function userInitials(name: string | null | undefined, email: string): string {
  const cleanName = (name ?? "").trim();
  if (cleanName) {
    const parts = cleanName.split(/\s+/).filter(Boolean);
    if (parts.length === 1) {
      return [...parts[0]!][0]!.toLocaleUpperCase("ru");
    }
    const first = [...parts[0]!][0] ?? "";
    const second = [...parts[1]!][0] ?? "";
    return (first + second).toLocaleUpperCase("ru");
  }
  const local = email.split("@")[0] ?? email;
  return ([...local][0] ?? "?").toLocaleUpperCase("ru");
}

export function userDisplayName(name: string | null | undefined, email: string): string {
  const cleanName = (name ?? "").trim();
  if (cleanName) return cleanName;
  return email.split("@")[0] ?? email;
}
